export const modalidadeModel = {
  modalidade: function () {
    return {
      id: '',
      descricao: ''
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/Modalidade/_model/modalidade.js